import { API_URL } from "../config/env";
import { FetcherResponse } from "../interfaces/api";
import { getAuthHeader } from "./helper";

const BASE_URL = API_URL;

export const fetcher = async <T>(
  url: string,
  init?: RequestInit
): Promise<FetcherResponse<T>> => {
  try {
    const isFormData = init?.body instanceof FormData;
    const response = await fetch(`${BASE_URL}${url}`, {
      ...init,
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...getAuthHeader(),
        ...(init?.headers || {}),
      },
      cache: "no-store",
    });
    if (!response.ok) {
      const errorData = await response.json();
      return {
        data: null,
        error: errorData.errors,
      };
    }
    const data = (await response.json()) as T;
    return { data, error: null };
  } catch (error) {
    if (error instanceof Error) {
      return { data: null, error };
    } else {
      return { data: null, error: new Error("An unknown error occurred") };
    }
  }
};
